export const isPhoneNumberInvalid = (phoneNumber) => {
  return (
    (phoneNumber && phoneNumber.replace(/ /g, "").includes("+33") && phoneNumber.replace(/ /g, "").length < 12) ||
    phoneNumber === "+"
  );
};
